import { FC } from "react";
import { Chip, Group, Loader, Space, Stack, Text } from "@mantine/core";

import { TRIAGE_REASONS, TriageReason } from "@shared/types";

import { AddCommentsFormComponent } from "./AddCommentsFormComponent";
import {
  IgnoreFutureFindingsOptions,
  IgnoreFutureFindingsOptionsProps,
} from "./IgnoreFutureFindingsOptions";

interface IgnoredTriageComponentProps {
  note: string;
  setNote: (e: any) => void;
  triageReason: TriageReason | undefined;
  setTriageReason: (e: any) => void;
  ignoreOptions?: IgnoreFutureFindingsOptionsProps;
  isLoadingIgnoreOptions?: boolean;
}
export const IgnoredTriageComponent: FC<IgnoredTriageComponentProps> = ({
  note,
  setNote,
  triageReason,
  setTriageReason,
  ignoreOptions,
  isLoadingIgnoreOptions,
}) => {
  return (
    <Stack gap={8}>
      <Space h="4" />
      <Text fz="xs" fw="700">
        Ignore reason
      </Text>

      <Chip.Group
        value={triageReason}
        onChange={(value) => setTriageReason(value as TriageReason)}
      >
        <Group gap={8}>
          {Object.entries(TRIAGE_REASONS).map(([reason, text]) => (
            <Chip
              key={reason}
              value={reason}
              size="xs"
              data-testid="IgnoreReasonChip"
            >
              {text}
            </Chip>
          ))}
        </Group>
      </Chip.Group>
      <AddCommentsFormComponent
        note={note}
        setNote={setNote}
        placeholderText="Comment on ignore reason"
      />
      {ignoreOptions ? (
        <IgnoreFutureFindingsOptions {...ignoreOptions} />
      ) : (
        isLoadingIgnoreOptions && <Loader />
      )}
    </Stack>
  );
};
